import React from "react";
import "./LegalPages.css";

const CookiePolicy = () => {
  return (
    <section className="legal-page">
      <h1>Cookie Policy</h1>
      <p>
        This Cookie Policy explains how <b>Mailsnappy</b> uses cookies and similar technologies to
        provide, customize, and improve your experience.
      </p>

      <h2>1. What Are Cookies?</h2>
      <p>
        Cookies are small text files stored on your device that help us recognize you and remember
        your preferences.
      </p>

      <h2>2. Types of Cookies We Use</h2>
      <ul>
        <li><b>Essential Cookies:</b> Required for site functionality.</li>
        <li><b>Analytics Cookies:</b> Help us analyze website performance.</li>
        <li><b>Marketing Cookies:</b> Used for personalized advertising.</li>
      </ul>

      <h2>3. Managing Cookies</h2>
      <p>
        You can choose to accept or decline cookies through your browser settings. Disabling cookies
        may affect some website functions.
      </p>

      <h2>4. Updates</h2>
      <p>
        We may modify this Cookie Policy from time to time to reflect new regulations or
        improvements to our website.
      </p>
    </section>
  );
};

export default CookiePolicy;
